import React, { useMemo, forwardRef } from 'react'
// import { useElementInViewport } from '/src/hooks'
import allStateGuidelines from './pickupGuidelinesState'

import './pickup_guidelines_element.scss'

const hasErrorCheck = (error) => error && error.ref

export const PickupGuidelinesElement = forwardRef(({ label, error, store, ...props }, ref) => {
  // const [viewValue, viewRef] = useElementInViewport(25)
  const hasError = hasErrorCheck(error)
  const storeGuidelines = useMemo(() => {
    const state = store ? store.field_mc_store_address.administrative_area : 'VIC'
    return allStateGuidelines[state]
  }, [store])

  const containerClass = ['pickup-guidelines-element-container']
  if (hasError) {
    containerClass.push('error')
  }

  return (
    <div className={containerClass.join(' ')}>
      <div className="pickup-guidelines">
        <div className="guidelines" dangerouslySetInnerHTML={{__html: storeGuidelines}} />
      </div>
      <div className="form-item form-item-checkbox mt-4">
        <label>
          <input type="checkbox" {...props} ref={ref} />
          {label}
        </label>
      </div>
      {hasError && (
        <div className="message mt-3">
          <p>Please agree to the pickup conditions</p>
        </div>
      )}
    </div>
  )
})